import { render } from "./EnIconDashboard.vue?vue&type=template&id=d5e3f06e"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/icons/navigation/EnIconDashboard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d5e3f06e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d5e3f06e', __exports__)) {
    api.reload('d5e3f06e', __exports__)
  }
  
  module.hot.accept("./EnIconDashboard.vue?vue&type=template&id=d5e3f06e", () => {
    api.rerender('d5e3f06e', render)
  })

}


export default __exports__